import { jsx as _jsx } from "react/jsx-runtime";
import { Sheet, SheetContent, SheetDescription, SheetTitle, } from '../../ui/sheet';
import { ErrorFallback } from '../error-fallback';
import { sidePanelStyle } from '../sheet-view-wrapper';
/** Come il layout `side-panel` della `SheetView`: aderente a destra. */
const SIZED_PANEL_CLASS = '!inset-y-0 !right-0 !w-auto !max-w-none !rounded-none !border-r-0 !border-l';
/**
 * Errore di una rotta figlia che apre un pannello laterale: l'errore resta
 * dentro il pannello, la lista sotto rimane visibile e utilizzabile dopo la
 * chiusura, invece della pagina d'errore a tutto schermo.
 */
export function SheetErrorFallback({ onClose, onRetry, size, className = 'w-full sm:max-w-3xl', }) {
    return (_jsx(Sheet, { open: true, onOpenChange: (open) => !open && onClose(), children: _jsx(SheetContent, { className: size ? SIZED_PANEL_CLASS : className, style: size ? sidePanelStyle(size) : undefined, describedBy: "sheet-description", disableOpenAnimation: true, children: _jsx(ErrorFallback, { variant: "panel", onRetry: onRetry, onClose: onClose, titleComponent: SheetTitle, descriptionComponent: SheetDescription }) }) }));
}
//# sourceMappingURL=index.js.map